export const SITE_SETTINGS = {
    BARCODE_LENGTH: 18,
};
